import React, { useState } from 'react'
import { X } from 'lucide-react'

interface OpenSessionModalProps {
  visible: boolean
  onClose: () => void
  onConfirm: (amount: number) => void
  loading?: boolean
}

export const OpenSessionModal: React.FC<OpenSessionModalProps> = ({
  visible,
  onClose,
  onConfirm,
  loading,
}) => {
  const [amount, setAmount] = useState(0)
  const [currentTime, setCurrentTime] = useState(new Date())

  React.useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date())
    }, 1000)
    return () => clearInterval(timer)
  }, [])

  if (!visible) return null

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    onConfirm(amount)
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-lg w-full max-w-sm p-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">Abrir Caja</h2>
          <button onClick={onClose}>
            <X />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-sm">Monto inicial</label>
            <input
              type="number"
              inputMode="numeric"
              step="1"
              value={amount}
              onChange={(e) => setAmount(Number(e.target.value))}
              className="mt-1 w-full border rounded px-3 py-2"
            />
          </div>
          <button
            type="submit"
            disabled={loading || amount <= 0}
            className="w-full bg-gray-800 text-white rounded py-2 hover:bg-gray-700 disabled:opacity-50"
          >
            {loading ? 'Abriendo...' : 'Abrir caja'}
          </button>
          <div className="text-center text-xs text-gray-400 mt-2 border-t border-gray-100 pt-3 flex items-center justify-center gap-1.5">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-500 animate-pulse" />
            Hora actual: <span className="font-semibold text-gray-600 tabular-nums">{currentTime.toLocaleTimeString('es-CO')}</span>
          </div>
        </form>
      </div>
    </div>
  )
}

export default OpenSessionModal
